import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { setPageTitle } from 'utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '1rem 1rem 1rem',
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
    },
    text: {
      minWidth: 0,
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      flexShrink: 0,
    },
    eyebrow: {
      fontSize: '0.70rem',
      fontWeight: 700,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: theme.palette.primary.main,
      marginBottom: 4,
    },
    title: {
      fontSize: '1.6rem',
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.2,
    },
    subtitle: {
      marginTop: 4,
      color: theme.palette.text.secondary,
      fontSize: '0.9rem',
    },
  }),
);

interface PageTitleProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function PageTitle({ eyebrow, title, subtitle, actions }: PageTitleProps) {
  const classes = useStyles();

  useEffect(() => {
    setPageTitle(`${title}${subtitle ? ` - ${subtitle}` : ''}`);
  }, [subtitle, title]);

  return (
    <div className={classes.root}>
      <div className={classes.text}>
        {eyebrow && <Typography className={classes.eyebrow}>{eyebrow}</Typography>}
        <Typography className={classes.title}>{title}</Typography>
        {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
      </div>
      {actions && <div className={classes.actions}>{actions}</div>}
    </div>
  );
}
